import { PostingDTO } from './data/dto/PostingDTO';

const nullAsString = 'null';
const nullAsNumber = 0;

export function obfuscatePosting(posting: PostingDTO): PostingDTO {
  const c: PostingDTO = structuredClone(posting);

  c.load.number = nullAsString;
  c.load.price = nullAsNumber;
  c.load.instructions = nullAsString;

  if (c.load.shipper) {
    c.load.shipper.name = nullAsString;
    c.load.shipper.contact_name = nullAsString;
    c.load.shipper.contact_phone = nullAsString;
    c.load.shipper.contact_email = nullAsString;
    c.load.shipper.address = nullAsString;
    c.load.shipper.city = nullAsString;
    c.load.shipper.state = nullAsString;
    c.load.shipper.zip = nullAsString;
    c.load.shipper.external_notes = nullAsString;
  }

  if (c.load.payment) {
    c.load.payment.terms = nullAsString;
  }

  if (c.carrier_load) {
    c.carrier_load.price = nullAsNumber;
    c.carrier_load.load_guid = nullAsString;
    c.carrier_load.posting_guid = nullAsString;
    c.carrier_load.counter_offer_price = nullAsNumber;
    c.carrier_load.delivery_date = nullAsString;
    c.carrier_load.pickup_date = nullAsString;
  }

  if (c.load.pickup.venue) {
    c.load.pickup.venue.city = nullAsString;
    c.load.pickup.venue.state = nullAsString;
    c.load.pickup.venue.zip = nullAsString;
    c.load.pickup.venue.metro_area = nullAsString;
  }

  if (c.load.delivery.venue) {
    c.load.delivery.venue.city = nullAsString;
    c.load.delivery.venue.state = nullAsString;
    c.load.delivery.venue.zip = nullAsString;
    c.load.delivery.venue.metro_area = nullAsString;
  }

  if (c.load.vehicles) {
    c.load.vehicles.forEach((vehicle) => {
      vehicle.year = nullAsString;
      vehicle.make = nullAsString;
      vehicle.model = nullAsString;
      vehicle.type = null;
      vehicle.is_inoperable = false;
    });
  }

  return c;
}

export function obfuscatePostingIfNeeded(posting: PostingDTO): PostingDTO {
  if (posting.load.is_restricted) {
    return obfuscatePosting(posting);
  }

  return posting;
}
